import { render, staticRenderFns } from "./WithdrawFromOrganization.vue?vue&type=template&id=56e47b32&scoped=true&"
import script from "./WithdrawFromOrganization.vue?vue&type=script&lang=js&"
export * from "./WithdrawFromOrganization.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawFromOrganization.vue?vue&type=style&index=0&id=56e47b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e47b32",
  null
  
)

export default component.exports